import { TFunction } from 'i18next'
import { ContractChangeValidationEntry } from './../../../../types'
import { ContractChangeType } from './FormikContractChangePayload'

export function createWarningMessagesForContractChanges(
  futureChanges: ContractChangeValidationEntry[],
  translateFunc: TFunction,
): Map<ContractChangeType, string[]> {
  const futureChangesByCategory = new Map<ContractChangeType, string[]>()

  for (const change of futureChanges) {
    const changeDate = new Date(change.date)
    if (!!change.bonus) {
      const bonusWarnings = futureChangesByCategory.get(ContractChangeType.Bonus) || []
      bonusWarnings.push(warning(`${change.bonus}`, changeDate, translateFunc))
      futureChangesByCategory.set(ContractChangeType.Bonus, bonusWarnings)
    }

    if (!!change.salary) {
      const salaryWarnings = futureChangesByCategory.get(ContractChangeType.Salary) || []
      salaryWarnings.push(warning(`${change.salary}`, changeDate, translateFunc))
      futureChangesByCategory.set(ContractChangeType.Salary, salaryWarnings)
    }

    if (!!change.employeeLevel) {
      const employeeLevelWarnings = futureChangesByCategory.get(ContractChangeType.EmployeeLevel) || []
      employeeLevelWarnings.push(warning(`${change.employeeLevel}`, changeDate, translateFunc))
      futureChangesByCategory.set(ContractChangeType.EmployeeLevel, employeeLevelWarnings)
    }

    if (!!change.nationalContractLevel) {
      const nationalContractLevelWarnings = futureChangesByCategory.get(ContractChangeType.NationalReferenceLevel) || []
      nationalContractLevelWarnings.push(warning(`${change.nationalContractLevel}`, changeDate, translateFunc))
      futureChangesByCategory.set(ContractChangeType.NationalReferenceLevel, nationalContractLevelWarnings)
    }

    if (!!change.governmentJobTitle) {
      const governmentJobTitleWarnings = futureChangesByCategory.get(ContractChangeType.GovernmentJobTitle) || []
      governmentJobTitleWarnings.push(warning(`${change.governmentJobTitle}`, changeDate, translateFunc))
      futureChangesByCategory.set(ContractChangeType.GovernmentJobTitle, governmentJobTitleWarnings)
    }
  }
  return futureChangesByCategory
}

const warning = (value: string, date: Date, t: TFunction) => {
  const now = new Date()
  const month = t(`global.month.${date.getMonth()}`)
  if (now.getFullYear() === date.getFullYear()) {
    return t('appraisalMeeting.stepContractChanges.modal.warnings', { change: value, date: month })
  } else {
    return t('appraisalMeeting.stepContractChanges.modal.warnings', { change: value, date: `${month} ${date.getFullYear()}` })
  }
}
